import updateCalendarEventsToDecline from '../actions/updateCalendarEventsToDecline';
import setEndDate from '../actions/setEndDate';
import { orchestrator } from 'satcheljs';
export default orchestrator(setEndDate, function (actionMessage) {
    var date = actionMessage.date;
    if (date) {
        updateCalendarEventsToDecline();
    }
});
//# sourceMappingURL=onSetEndDateOrchestrator.js.map